export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface Toast {
  type: ToastType;
  title: string;
  subtitle?: string;
  duration: number;
  id: string;
}